<template>
    <div ref="phoneInputContainerRef">
        <phone-number
            v-bind="fieldBind"
            initial-value=""
            :disabled="disabled"
            otp-countries
        />
        <span
            v-if="error"
            id="phone-error"
            class="text-small text-red-600"
            >{{ error }}</span
        >
    </div>
</template>

<script setup lang="ts">
import PhoneNumber from '~/components/Input/PhoneNumber.vue'
import { ref } from 'vue'

defineProps<{
    disabled: boolean
    error: string | undefined
    fieldBind: Record<string, unknown>
}>()

const phoneInputContainerRef = ref<HTMLElement | null>(null)

function focus() {
    phoneInputContainerRef.value
        ?.querySelector<HTMLInputElement>('input')
        ?.focus()
}

defineExpose({ focus })
</script>
